export default function FormBodyRow(props) {
  return (
    <div className="grid grid-cols-24 gap-4 md:gap-6">
      {props.children}
    </div>
  );
}
